import FetchClient from "@dpdgroupuk/fetch-client";
import { EnvUtil, CookieUtil } from "../utils";
import { LocalServiceFsApis, LocalServicePrinterApis } from "./routers";

class LocalApisClient extends FetchClient {
  static getAppPort() {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("appPort") || CookieUtil.get("appPort") || "2917";
  }

  constructor(options = {}) {
    super({
      credentials: "include",
      baseUrl: EnvUtil.getLocalApisUrl(window.location, options.port || LocalApisClient.getAppPort()),
      ...options
    });
    this.fs = new LocalServiceFsApis(this);
    this.printer = new LocalServicePrinterApis(this);
  }

  getApisBaseUrl() {
    return this.options.baseUrl;
  }

  async ping({
    timeout = 1000
  } = {}) {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await this.get({
      path: "/ping",
      options: {
        signal: controller.signal
      }
    });
    clearTimeout(id);
    return response;
  }

}

export default LocalApisClient;